import React, { useEffect, useRef } from 'react';


function Services() {
    const box1Ref = useRef(null);
    const box2Ref = useRef(null);
    const box3Ref = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            const value = window.scrollY;
            const width = window.innerWidth;

            if (width < 768) { 
                box1Ref.current.style.transform = `translateX(10)`;
                box2Ref.current.style.transform = `translateX(10)`;
                box3Ref.current.style.transform = `translateX(10)`;
                box1Ref.current.style.top = `${Math.min(value + 2000, 2850)}px`;
                box2Ref.current.style.top = `${Math.min(value + 2000, 2850)}px`;
                box3Ref.current.style.top = `${Math.min(value + 2000, 2850)}px`;
            } else if (width < 1024) { 
                box1Ref.current.style.transform = `translateX(-${value / 1.5}px)`;
                box2Ref.current.style.transform = `translateX(-${value / 1.5}px)`;
                box3Ref.current.style.transform = `translateX(-${value / 1.5}px)`;
                box1Ref.current.style.top = `${Math.min(value + 2000, 2700)}px`;
                box2Ref.current.style.top = `${Math.min(value + 2000, 2700)}px`;
                box3Ref.current.style.top = `${Math.min(value + 2000, 2700)}px`;
            } else if (width < 1280) { 
                box1Ref.current.style.transform = `translateX(-${value / 1}px)`;
                box2Ref.current.style.transform = `translateX(-${value / 1}px)`;
                box3Ref.current.style.transform = `translateX(-${value / 1}px)`;
                box1Ref.current.style.top = `${Math.min(value + 2000, 2700)}px`;
                box2Ref.current.style.top = `${Math.min(value + 2000, 2700)}px`;
                box3Ref.current.style.top = `${Math.min(value + 2000, 2700)}px`;
            } else { 
                box1Ref.current.style.transform = `translateX(-${value / 0.8}px)`;
                box2Ref.current.style.transform = `translateX(-${value / 0.8}px)`;
                box3Ref.current.style.transform = `translateX(-${value / 0.8}px)`;
                box1Ref.current.style.top = `${Math.min(value + 2000, 2700)}px`;
                box2Ref.current.style.top = `${Math.min(value + 2000, 2700)}px`;
                box3Ref.current.style.top = `${Math.min(value + 2000, 2700)}px`;
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
      }, []);

  return (
    <div className='flex justify-center gap-5 flex-wrap md:mt-[500px]'>
<div ref={box1Ref} className="md:absolute md:-right-[130%] lg:-right-[120%] w-72 bg-lime-300 h-96 border border-gray-300 rounded-lg shadow-lg">
<div className="md:absolute right-2 bottom-2 w-72 h-96 bg-gradient-to-t from-blue-600 via-purple-300 to-lime-400 border border-gray-300 rounded-lg shadow-lg">
    <div>
        <img className='w-52 h-52 m-auto mt-10' src="/Image/THEKUB-qIjIZd-J.png" alt="" />
        <h2 className='text-center font-bold text-slate-700 mt-2'>THE KUB</h2>
        <a className='mx-auto mt-10 flex justify-center items-center w-16 h-8 rounded-md font-bold text-blue-800 bg-lime-300' href="">voir</a>
    </div>
    </div> 
    </div>  
    <div ref={box2Ref} className="md:absolute md:-right-[170%] lg:-right-[150%] w-72 bg-lime-300 h-96 border border-gray-300 rounded-lg shadow-lg">
<div className="md:absolute right-2 bottom-2 w-72 h-96 bg-gradient-to-t from-blue-600 via-purple-300 to-lime-400 border border-gray-300 rounded-lg shadow-lg">
<div>
        <img className='w-52 h-52 m-auto mt-10' src="/Image/ELEMATE-GwcOi4Yd.png" alt="" />
        <h2 className='text-center font-bold text-slate-700 mt-2'>THE KUB</h2>
        <a className='mx-auto mt-10 flex justify-center items-center w-16 h-8 rounded-md font-bold text-blue-800 bg-lime-300' href="">voir</a>
    </div>
    </div>             
    </div> 
    <div ref={box3Ref} className="md:absolute md:-right-[210%] lg:-right-[180%] w-72 bg-lime-300 h-96 border border-gray-300 rounded-lg shadow-lg">
<div className="md:absolute right-2 bottom-2 w-72 h-96 bg-gradient-to-t from-blue-600 via-purple-300 to-lime-400 border border-gray-300 rounded-lg shadow-lg">
<div>
        <img className='w-52 h-52 m-auto mt-10' src="/Image/WORLDCAST--jGArdOp.png" alt="" />
        <h2 className='text-center font-bold text-slate-700 mt-2'>THE KUB</h2>
        <a className='mx-auto mt-10 flex justify-center items-center w-16 h-8 rounded-md font-bold text-blue-800 bg-lime-300' href="">voir</a>
    </div>
    </div>             
    </div> 
    </div>
  )
}

export default Services